<div class="paginator-container" *ngIf="paginatorInfo && paginatorInfo.totalItems > 20">

  <numbered-pagination
  [value]="paginatorInfo.pageIndex"
  [pageLength]="options.pageLength"
  [pageNumberInSection]="options.pageNumberInSection"
  (pageChanged)="pageChanged.emit($event)">
  </numbered-pagination>

  <div class="paginator-settings">
    <div class="paginator-settings__counter dds-body">{{ renderedFirstIndex }} - {{ renderedCount }} of {{ paginatorInfo.totalItems }}</div>

    <app-select
      [customClass]="selectOptions.customClass"
      [value]="initPageValue"
      (valueChanged)="updateOptions($event)"
    >
      <app-select-item
        *ngFor="let item of selectItems"
        [heading]="item.heading | translate"
        [customClass]="item.customClass"
        [value]="item.value"
      >
      </app-select-item>
    </app-select>
  </div>
</div>
